import request from '@/utils/sap-request'

// 1.1客户主数据查询
export const getClientList = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/masterdata/get_bp01',
    method: 'POST',
    data
  })
}

// 1.2客户维护查询
export const getClientDetail = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/get_bp02',
    method: 'POST',
    data
  })
}

// 1.3客户修改
export const clientSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/bp_save',
    method: 'POST',
    data
  })
}

// 1.4客户新增
export const clientCreate = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/masterdata/bp_create',
    method: 'POST',
    data
  })
}

// 客户关系报表
export const getClientRelation = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/get_bp_relation',
    method: 'POST',
    data
  })
}

// 客户地址报表
export const getClientAddress = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/get_bp_address',
    method: 'POST',
    data
  })
}

// 客户历史变更
export const getClientHistory = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/get_bp_history',
    method: 'POST',
    data
  })
}

// 价格主数据查询
export const getPriceList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/price01',
    method: 'POST',
    data
  })
}

// 价格主数据保存
export const savePrice = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/price03',
    method: 'POST',
    data
  })
}

// 产品主数据查询
export const getProductList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/matlist',
    method: 'POST',
    data
  })
}

// 产品主数据保存
export const saveProduct = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/matbuild',
    method: 'POST',
    data
  })
}

// 产品营销单元批量删除
export const saveProductDel = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/produc',
    method: 'POST',
    data
  })
}

// 销售订单中销售计划编号查询
export const getSalePlanNumber = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/sales_plan_ovs',
    method: 'POST',
    data
  })
}

// 查询收货地址
export const getCutAddress = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/get_bp_sh_addr',
    method: 'POST',
    data
  })
}

/**
 * 查询团购运达方
 *
 * @param {*} params
 */
export function apiFindGroupArrival(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/partner_ovs',
    method: 'post',
    data
  })
}

/**
 * 客户可售产品查询
 *
 * @param {*} params
 */
export function apiFindClientProd(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/get_bp_product',
    method: 'post',
    data
  })
}

/**
 * 价格查询详情
 *
 * @param {*} params
 */
export function apiGetPriceDetail(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/get_price_by_id',
    method: 'post',
    data
  })
}

/**
 * 产品查询
 * @param {*} params
 */
export function apiProductDetail(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/get_mat_by_id',
    method: 'post',
    data
  })
}

/**
 * 价格作废
 * @param {*} params
 */
export function apiPriceBatchinValid(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/p_batch_invalid',
    method: 'post',
    data
  })
}

/**
 * 价格批导查询
 * @param {*} params
 */
export function apiPriceImportList(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/get_p_approve',
    method: 'post',
    data
  })
}
/**
 * 价格批导审核
 * @param {*} params
 */
export function apiPriceApprove(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/price_approve',
    method: 'post',
    data
  })
}
/**
 * 客户主数据批导
 * @param {*} params
 */
export function apiClientImport(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/bp_import',
    method: 'post',
    data
  })
}
/**
 * 价格主数据批导
 * @param {*} params
 */
export function apiPriceImport(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/price04',
    method: 'post',
    data
  })
}
/**
 * 产品营销战区查询
 * @param {*} params
 */
export function apiProdSalesList(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/mat_sales',
    method: 'post',
    data
  })
}
/**
 * 价格变动报表
 * @param {*} params
 */
export function apiPriceChange(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/price_bd_report',
    method: 'post',
    data
  })
}
/**
 * 客户类型变更历史记录
 * @param {*} params
 */
export function apiTypeChangeList(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/get_bp_type',
    method: 'post',
    data
  })
}
/**
 * 品牌推荐官
 * @param {*} params
 */
export function getReferrals(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_referrals',
    method: 'post',
    data
  })
}
/**
 * 客户关系维护
 * @param {*} params
 */
export function apiCrmMaintenance(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/crm_maintenance',
    method: 'post',
    data
  })
}
/**
 * 获取老要货报表信息
 * @param {*} params
 */
export function apiGetLwgBB(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_lwg_bb',
    method: 'post',
    data
  })
}
/**
 * 获取存新酒客户
 * @param {*} params
 */
export function apiCxjBpMod(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/cxj_bp_mod',
    method: 'post',
    data
  })
}
/**
 * 获取存新酒客户地址
 * @param {*} params
 */
export function apiCxjAddrMod(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/cxj_addr_mod',
    method: 'post',
    data
  })
}
/**
 * 获取经销商报表
 * @param {*} params
 */
export function apiGylBp(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/gyl_bp',
    method: 'post',
    data
  })
}
/**
 * 获取产品报表
 * @param {*} params
 */
export function apiGylPro(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/gyl_pro',
    method: 'post',
    data
  })
}

/**
 * 公关团购产品维护
 * @param {*} data
 */
export function apiGroupPurchaseProduct(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/ggtg_pro_mod',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sap/client-sap.js